var it = {
	"neptune.Button.loadingAriaLabel": "caricamento",
	"neptune.Chips.ariaLabel": "Rimuovi {choice}",
	"neptune.ClearButton.ariaLabel": "Elimina",
	"neptune.CloseButton.ariaLabel": "Chiudi",
	"neptune.DateInput.day.label": "Giorno",
	"neptune.DateInput.day.placeholder": "GG",
	"neptune.DateInput.month.label": "Mese",
	"neptune.DateInput.year.label": "Anno",
	"neptune.DateInput.year.placeholder": "AAAA",
	"neptune.DateLookup.day": "giorno",
	"neptune.DateLookup.goTo20YearView": "Vai alla vista su 20 anni",
	"neptune.DateLookup.month": "mese",
	"neptune.DateLookup.next": "continua",
	"neptune.DateLookup.previous": "indietro",
	"neptune.DateLookup.selected": "selezionata",
	"neptune.DateLookup.twentyYears": "20 anni",
	"neptune.DateLookup.year": "anno",
	"neptune.FlowNavigation.back": "torna al passaggio precedente",
	"neptune.Info.ariaLabel": "Maggiori informazioni",
	"neptune.Label.optional": "(Facoltativo)",
	"neptune.Link.opensInNewTab": "(si apre in una nuova scheda)",
	"neptune.MoneyInput.Select.placeholder": "Seleziona un'opzione...",
	"neptune.MoneyInput.Select.selectCurrencyLabel": "Scegli la valuta",
	"neptune.PhoneNumberInput.SelectInput.placeholder": "Seleziona un'opzione...",
	"neptune.Select.searchPlaceholder": "Cerca...",
	"neptune.SelectInput.noResultsFound": "Nessun risultato trovato",
	"neptune.SelectOption.action.label": "Scegli",
	"neptune.SelectOption.selected.action.label": "Modifica l'opzione scelta",
	"neptune.StatusIcon.iconLabel.error": "Errore:",
	"neptune.StatusIcon.iconLabel.information": "Informazioni:",
	"neptune.StatusIcon.iconLabel.pending": "In attesa:",
	"neptune.StatusIcon.iconLabel.success": "Fatto:",
	"neptune.StatusIcon.iconLabel.warning": "Attenzione:",
	"neptune.Summary.statusDone": "Completato",
	"neptune.Summary.statusNotDone": "Da completare",
	"neptune.Summary.statusPending": "In corso",
	"neptune.Table.actionHeader": "Azione",
	"neptune.Table.emptyData": "Nessun risultato trovato",
	"neptune.Table.loaded": "I dati della tabella sono stati caricati",
	"neptune.Table.loading": "I dati della tabella sono in fase di caricamento",
	"neptune.Table.refreshPage": "Aggiorna la pagina",
	"neptune.Upload.csButtonText": "Carica un altro documento?",
	"neptune.Upload.csFailureText": "Caricamento fallito. Per favore riprova",
	"neptune.Upload.csSuccessText": "Caricamento completato!",
	"neptune.Upload.csTooLargeMessage": "Carica un file inferiore a {maxSize}MB",
	"neptune.Upload.csWrongTypeMessage": "Formato del documento non supportato. Riprova con un formato diverso",
	"neptune.Upload.psButtonText": "Annulla",
	"neptune.Upload.psProcessingText": "Caricamento...",
	"neptune.Upload.retry": "Riprova",
	"neptune.Upload.usButtonText": "O seleziona un documento",
	"neptune.Upload.usDropMessage": "Rilascia il documento per iniziare il caricamento",
	"neptune.Upload.usPlaceholder": "Trascina e rilascia un file inferiore a {maxSize}MB",
	"neptune.UploadButton.allFileTypes": "Tutti i tipi di file",
	"neptune.UploadButton.dropFiles": "Rilascia file per iniziare a caricare",
	"neptune.UploadButton.instructions": "{fileTypes}, minore di {size}MB",
	"neptune.UploadButton.maximumFiles": "Max {maxFiles} file.",
	"neptune.UploadButton.uploadFile": "Carica un file",
	"neptune.UploadButton.uploadFiles": "Carica i file",
	"neptune.UploadInput.deleteModalBody": "Rimuovere questo file lo cancellerà dal nostro sistema.",
	"neptune.UploadInput.deleteModalCancelButtonText": "Annulla",
	"neptune.UploadInput.deleteModalConfirmButtonText": "Rimuovi",
	"neptune.UploadInput.deleteModalTitle": "Vuoi davvero cancellare questo file?",
	"neptune.UploadInput.fileIsTooLarge": "File troppo grande",
	"neptune.UploadInput.fileTypeNotSupported": "Tipo di file non supportato",
	"neptune.UploadInput.maximumFilesAlreadyUploaded": "Siamo spiacenti, questo caricamento non è riuscito perché possiamo accettare solo {maxFilesAllowed} file alla volta.",
	"neptune.UploadItem.deleting": "Eliminando...",
	"neptune.UploadItem.removeFile": "Rimuovi file {filename}",
	"neptune.UploadItem.uploaded": "Caricato",
	"neptune.UploadItem.uploadedFile": "File caricato",
	"neptune.UploadItem.uploading": "Caricamento...",
	"neptune.UploadItem.uploadingFailed": "Caricamento fallito"
};

export { it as default };
//# sourceMappingURL=it.json.mjs.map
